function initHandsClickable() {
  // 手役記事のクリック可能な行の処理
  document.querySelectorAll('.hands-clickable-row:not([data-initialized])').forEach(function(element) {
    element.addEventListener('click', function(event) {
      const href = this.getAttribute('data-href');
      if (href) {
        window.location.href = href;
      }
    });
    
    // カーソルをポインターに変更
    element.style.cursor = 'pointer';
    element.setAttribute('data-initialized', 'true');
  });
}

// 初回読み込み時
document.addEventListener('DOMContentLoaded', initHandsClickable);

// Turbolinks対応
document.addEventListener('turbolinks:load', initHandsClickable);